import { IconRosetteDiscountCheckFilled } from "@tabler/icons-react";
import Button from "../../components/Button";
import { useNavigate } from "react-router";

function Successful() {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center h-full py-10">
      <div className="bg-gray-50 border border-gray-200 rounded-3xl overflow-hidden p-9 max-w-[430px] w-full mx-auto space-y-6">
        <IconRosetteDiscountCheckFilled
          size={80}
          className="text-green-600 mx-auto"
        />
        <h2 className="text-2xl text-gray-800 font-semibold text-center">
          Contract has been submitted.
        </h2>
        <Button
          variant="blue"
          btnClassName="w-full"
          onClick={() => navigate(`/contracts`)}
        >
          Return To Contract Dashboard
        </Button>
      </div>
    </div>
  );
}

export default Successful;
